namespace Ir.Components.Workbook.Settings.Items.TabDetailSetting {
    export interface ITabDetailSettingParams {
        label?: string;
        tab: KnockoutObservable<number>;
        onSelected?(newValue: number, oldValue: number);
        onClear?(oldValue: number);
    }
    interface IViewModel {
        textBoxOptions: any;
        popoverButtonOptions: any;
        removeButtonOptions: any;
        label: string;
    }

    interface IParams {
        config: ITabDetailSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        let tab = params.config.tab;

        self.label = params.config?.label ?? "Tab for Details";

        self.popoverButtonOptions = {
            icon: "ms ir-find-icon",
            hint: ko.computed(function () {
                return "Choose the " + self.label;
            }),
            //disabled: params.config.disabled ?? false,
            onClick: function (e) {
                let onSelected = function (id: number) {
                    if (params.config.onSelected) {
                        params.config.onSelected(id, tab());
                    }
                    tab(id);
                };
                WorkbookTab.showTabsPopover($(e.element).siblings(".textbox-item"), onSelected);
            }
        };

        self.removeButtonOptions = {
            icon: "ms ir-clear-icon",
            hint: ko.computed(function () {
                return "Remove the " + self.label;
            }),
            //disabled: params.config.disabled ?? false,
            onClick: function (e) {
                tab(null);

                if (params.config.onClear) {
                    params.config.onClear(tab());
                }
            }
        };

        let name = ko.computed(function (this: KnockoutObservable<number>) {
            let nameValue = "";
            let tabId = tab();
            if (tabId) {
                let workbookTab = workbook.workbookConfig.tabs().find(x => x.id() === tabId);
                if (workbookTab) {
                    nameValue = workbookTab.name();
                }
            }
            return nameValue;
        });

        self.textBoxOptions = {
            value: name,
            width: "100%",
            readOnly: true,
        };
    }
}